import React from "react";
import Routes from "./Routes/index";
import Loader from "./components/Common/Loader";
import { ToastContainer } from "react-toastify";
import "./assets/scss/theme.scss";
function App() {
  return (
    <React.Fragment>
      <ToastContainer />
      <Loader />
      <Routes />
    </React.Fragment>
  );
}

export default App;
